const statuses = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Blocked",
    value: "Blocked",
  },
  {
    label: "Pending",
    value: "Pending",
  },
];

export default statuses;
